<template>
  <v-row justify="center">
    <v-dialog v-model="visible" persistent max-width="600px">
      <v-form ref="form" @submit.prevent="handleSubmit">
        <v-card :loading="loading">
          <v-card-title>
            <span class="headline">{{ $t("modal.addUser.title") }}</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-alert
                v-if="error"
                border="left"
                colored-border
                type="error"
                elevation="2"
              >
                {{ error }}
              </v-alert>
              <v-row>
                <!-- name -->
                <v-col cols="6">
                  <v-text-field
                    :label="$t('label.name')"
                    v-model="user.name"
                    :rules="[rules.required]"
                  />
                </v-col>

                <!-- title -->
                <v-col cols="6">
                  <v-text-field
                    :label="$t('label.title')"
                    v-model="user.title"
                  />
                </v-col>

                <!-- email -->
                <v-col cols="6">
                  <v-text-field
                    :label="$t('label.email')"
                    :hint="$t('hint.emailLogin')"
                    persistent-hint
                    v-model="user.email"
                    :rules="[rules.required, rules.email]"
                    validate-on-blur
                  />
                </v-col>

                <!-- phone -->
                <v-col cols="6">
                  <v-text-field
                    :label="$t('label.phone')"
                    v-model="user.phone"
                  />
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    :label="$t('label.password')"
                    type="password"
                    v-model="user.password"
                    :rules="passwordRules"
                  />
                </v-col>

                <v-col cols="12">
                  <v-autocomplete
                    v-model="user.permissions"
                    :items="permissions"
                    :label="$t('label.permissions')"
                    :hint="$t('hint.permissionsDoc')"
                    multiple
                    persistent-hint
                    item-text="name"
                    item-value="permission"
                    return-object
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn color="blue darken-1" class="white--text" text @click="onCancel">{{
              $t("label.cancel")
            }}</v-btn>
            <v-btn color="blue darken-1" type="submit" :loading="loading">{{
              $t("label.save")
            }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </v-row>
</template>

<script>
import {passwordRules} from "../utils/userUtils"
export default {
  name: "AddUser",
  data() {
    return {
      passwordRules,
      user: {},
      rules: {
        required: (value) => !!value || "Required.",
        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        },
      },
    };
  },
  props: {
    error: {},
    permissions: {},
    loading: {
      type: Boolean,
      default: false,
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleSubmit() {
      if (!this.$refs.form.validate()) {
        return false;
      }
      this.$emit("onConfirmed", this.user);
    },
    onCancel() {
      this.$refs.form.reset();
      this.$emit("onCancelled");
    },
  },
  created: function () {},
};
</script>